import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, mergeProps as _mergeProps, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45c66232"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "order-status fw600" }
const _hoisted_3 = { class: "header-row" }
const _hoisted_4 = { class: "status-tips" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "copy",
  id: "copyItem"
}, "复制", -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "aduit-decription" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "customer-arrow" }, null, -1))
const _hoisted_9 = { class: "button-wrap" }
const _hoisted_10 = {
  key: 0,
  class: "confirm-shipment-tip"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "收到货物后请及时确认收货！", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "超过7天未签收系统将自动签收", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]

import AppHeader from '@/components/Header.vue'
import { ref, onMounted, computed, onActivated, onDeactivated } from 'vue'
import { PullRefresh, Button, Toast, Dialog } from 'vant'
import ReceiptInfo from './components/receipt-info.vue'
import { useClipboard } from '@/compositions/common'
import DetailBillBlock from './components/detail-bill-block.vue'
import DeviceInfo from './components/device-info.vue'
import ApplyInfo from './components/apply-info.vue'
import CommonFooterWrap from '@/components/CommonFooterWrap.vue'
import { NameplateReissueOrderDetailButtonTextMap } from '@/defination/nameplate-reissue'
import {
  getNameplateReissueDetail,
  receiptNameplateReissue,
  cancelNameplateReissue,
  payNameplateReissue,
  payNameplateReissueResult,
  submitNameplateReissueOrderInvoiceInfo,
} from '@/apis/nameplate-reissue'
import { useRoute, useRouter } from 'vue-router'
import { useOrderApply } from '@/compositions/invoice/index'
import {
  showToastLoading,
  showNormalToast,
  showToastSuccess,
  showConfirmModal,
  clearToast,
} from '@/utils/tools'
import { useAppPay } from '@/compositions/usePay'
import {
  NameplateReissueOrderStatusColorMap,
  NameplateReissueOrderStatusTextMap,
} from '@/defination/nameplate-reissue'
import { commonErrorHandle, getErrorMessage } from '@/utils/error-handle'
import type { ItemInfoProps } from './components/item-info.vue'
import wx from 'weixin-js-sdk'
import { useStore } from 'vuex'
import {
  NameplateReissueDetail,
  NameplateReissueList,
  NameplateReissueApply,
} from '@/store/nameplate-reissue'
import AppHost, { isApp } from '@/utils/app'
import OrderInoviceApply from '@/components/invoice/order-inovice-apply.vue'


// eslint-disable @typescript-eslint/ban-ts-comment
import { defineComponent } from 'vue'
const __default__ = defineComponent({
  name: 'nameplate-reissue-detail',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const $route = useRoute()
const $router = useRouter()
const refreshing = ref(false)
const stauts = ref()
const isShowDetailBillBlock = computed(() => {
  return ![10, 20, 70].includes(stauts.value)
})

const { initClipboard } = useClipboard({
  text: () => detail.value?.sn,
})
const {
  invoiceData,
  scrollToInvoiceDom,
  invoiceDomInit,
  changeHandle: invoiceChangeHandle,
  getOrderInvocieSubmitParams,
  verify: invoiceVerify,
} = useOrderApply()
const deviceInfo = [
  {
    title: '设备信息',
    isRequired: true,
    prop: 'sn',
    isEdit: false,
    value: '',
  },
  {
    title: '产品型号',
    isRequired: true,
    value: '',
    isEdit: false,
    prop: 'product',
    tip: '部分机型在不同地区为不同型号标准，请根据所在地区需要选择产品型号！',
  },
  {
    title: '补办类型',
    isRequired: true,
    isEdit: false,
    prop: 'reissueType',
    value: '',
  },
  {
    title: '出厂编码',
    prop: 'factoryCode',
    isEdit: false,
    value: '',
  },
  {
    title: '飞控编码',
    isEdit: false,
    prop: 'flightCode',
    value: '',
  },
  {
    title: '地面站（单控）编码',
    isEdit: false,
    isRequired: true,
    prop: 'floorCode',
    value: '',
  },
  {
    title: '生产日期',
    isEdit: false,
    prop: 'time',
    isRequiredBottom: false,
    value: '',
  },
] as Array<ItemInfoProps>
const applyInfo = [
  {
    title: '申请原因',
    isRequired: true,
    prop: 'applyReason',
    isEdit: false,
    value: '',
  },
  {
    title: '原因说明',
    prop: 'reasonDescription',
    value: '',
    isEdit: false,
    isRequired: true,
  },
  {
    title: '所有权证明说明',
    prop: 'ownerDescription',
    isEdit: false,
    value: '',
  },
  {
    title: '附图',
    prop: 'attachImages',
    isEdit: false,
    imgags: [],
  },
  {
    title: '上传附件',
    isEdit: false,
    prop: 'uploadAttach',
    isRequiredBottom: false,
    imgags: [],
  },
] as Array<ItemInfoProps>
let detail = ref({
  sn: '',
  pay_amount: 0,
  order_no: '',
  status: -1,
  guid: '',
  shipmentNum: '',
  statusText: '',
  statusColor: '',
  payInfo: {
    isFree: false,
    sum: '',
    billArr: [],
  },
  receiptInfo: {
    name: '',
    phone: '',
    address: '',
    shipmentNum: '',
  },
  deviceInfo,
  applyInfo,
  verified_description: '',
  isShowBill: false,
  invoice_apply: null,
})
let isNotPassed = computed(() => detail.value.status === 20)
let isShowShipmentNum = computed(() => [50, 60].includes(detail.value.status))
let isShowCancel = computed(() => [10, 20, 30].includes(detail.value.status))
const canPay = computed(() => detail.value?.status === 30)

// 更新维修单发票信息
async function updateInvoiceInfoHandle(): Promise<void> {
  const data = invoiceData.value
  const params = getOrderInvocieSubmitParams()
  try {
    await submitNameplateReissueOrderInvoiceInfo($route.query.guid as string, params)
  } catch (error) {
    console.log('error', error)
    const message = `发票选择失败: ${getErrorMessage(error)}`
    showNormalToast(message)
  }
  return null
}
async function initPageDetail(refresh = false) {
  if (!refresh) {
    showToastLoading()
  }
  if (invoiceData.value && invoiceData.value?.invoice_guid) {
    await updateInvoiceInfoHandle()
  }
  try {
    let getNameplateReissueDetailData = await getNameplateReissueDetail($route.query.guid as string)
    detail.value.sn = getNameplateReissueDetailData.order_no
    // 设备机型类型 UAV 无人机 AUTO 自驾仪 UGV 无人车
    stauts.value = getNameplateReissueDetailData.status
    let isAutopilot = getNameplateReissueDetailData.model_type?.indexOf('AUTO') === 0
    let isCar = getNameplateReissueDetailData.model_type === 'UGV'
    detail.value.invoice_apply = getNameplateReissueDetailData.invoice_apply
    invoiceChangeHandle(detail.value.invoice_apply)
    detail.value.pay_amount = getNameplateReissueDetailData.pay_amount
    detail.value.order_no = getNameplateReissueDetailData.order_no
    detail.value.shipmentNum = getNameplateReissueDetailData.express_info.number
    detail.value.status = getNameplateReissueDetailData.status
    detail.value.statusText = NameplateReissueOrderStatusTextMap.get(
      getNameplateReissueDetailData.status
    )
    detail.value.statusColor = NameplateReissueOrderStatusColorMap.get(
      getNameplateReissueDetailData.status
    )
    detail.value.receiptInfo = {
      ...getNameplateReissueDetailData.receive_express,
      address: [
        getNameplateReissueDetailData.receive_express.province,
        getNameplateReissueDetailData.receive_express.city,
        getNameplateReissueDetailData.receive_express.area,
        getNameplateReissueDetailData.receive_express.address,
      ].join('/'),
      shipmentNum: getNameplateReissueDetailData.express_info.number || '',
    }
    detail.value.payInfo.isFree = getNameplateReissueDetailData.service_type === 2
    detail.value.payInfo.sum = String(getNameplateReissueDetailData.pay_amount)
    detail.value.payInfo.billArr = (getNameplateReissueDetailData.details || []).map((_) => {
      return {
        title: _.name,
        num: _.num,
        price: _.raw_price,
        sum: _.pay_amount,
      }
    })
    detail.value.guid = getNameplateReissueDetailData.guid
    detail.value.verified_description = getNameplateReissueDetailData.verified_description
    if (isCar) {
      let isCarDeviceInfo = deviceInfo.filter((_) => !['flightCode', 'floorCode'].includes(_.prop))
      detail.value.deviceInfo = isCarDeviceInfo
    } else if (isAutopilot) {
      let iisAutopilotDeviceInfo = deviceInfo.filter((_) => !['floorCode'].includes(_.prop))
      detail.value.deviceInfo = iisAutopilotDeviceInfo
    }
    detail.value.deviceInfo = detail.value.deviceInfo.map((_) => {
      switch (_.prop) {
        case 'sn':
          _.value = getNameplateReissueDetailData.serial_number
          break
        case 'product':
          _.value = getNameplateReissueDetailData.product_model
          break
        case 'reissueType':
          _.value = (getNameplateReissueDetailData.namplate_types_text || []).join('、')
          break
        case 'factoryCode':
          _.value = getNameplateReissueDetailData.serial_number
          break
        case 'flightCode':
          _.value = getNameplateReissueDetailData.flight_control_no
          break
        case 'floorCode':
          _.value = getNameplateReissueDetailData.ground_station_no
          break
        case 'time':
          _.value = getNameplateReissueDetailData.factory_at
            ? getNameplateReissueDetailData.factory_at.split(' ')[0]
            : ''
          break
      }
      return _
    })
    detail.value.applyInfo = detail.value.applyInfo.map((_) => {
      switch (_.prop) {
        case 'applyReason':
          _.value = getNameplateReissueDetailData.reason_type_text
          break
        case 'reasonDescription':
          _.value = getNameplateReissueDetailData.reason
          break
        case 'ownerDescription':
          _.value = getNameplateReissueDetailData.description
          break
        case 'attachImages':
          _.imgags = getNameplateReissueDetailData.images || []
          break
        case 'uploadAttach':
          _.imgags = getNameplateReissueDetailData.files || []
          break
      }
      return _
    })
    detail.value.isShowBill = getNameplateReissueDetailData.can_invoice
    Toast.clear()
  } catch (error) {
    Toast.clear()
    commonErrorHandle(error)
  }
  refreshing.value = false
}

const onRefresh = () => {
  refreshing.value = true
  initPageDetail(true)
}

onMounted(() => {
  $store.commit('NameplateReissue/addCacheRouteName', NameplateReissueDetail)
  initPageDetail()
  initClipboard('#copyItem')
})
onActivated(() => {
  $store.commit('NameplateReissue/addCacheRouteName', NameplateReissueDetail)
})
async function cancelHandle() {
  try {
    await showConfirmModal({
      title: '确认是否取消该申请单？',
      confirmButtonColor: 'rgba(0, 195, 120, 1)',
    })
    showToastLoading()
    await cancelNameplateReissue(detail.value.guid)
    $store.commit('NameplateReissue/removeCacheRouteName', NameplateReissueList)
    initPageDetail()
  } catch (e) {
    console.log(e)
  }
}
const { compatibleWechatAndCmdPay, judgeCanUseMiniProgramPay } = useAppPay()
const $store = useStore()
const isMiniProgram = computed(() => {
  return $store.getters.isMiniProgram
})
let timeId: number
function handleSearchOrderPayStatus(pay_order_no: string, immediately = false) {
  // 查询单据支付状态
  let i = 0
  let searching = false
  function handleFn() {
    showToastLoading({
      message: '支付结果查询中',
    })
    if (i >= 12) {
      clearInterval(timeId)
      clearToast()
      Dialog.confirm({
        title: '查询结果失败',
        message: `支付订单号${pay_order_no}，请尝试继续校验，如需帮助请联系客服：400-780-3131`,
        confirmButtonText: '重新查询',
        cancelButtonText: '取消查询',
        className: 'reserve-dialog',
        width: 304,
      })
        .then(async () => {
          try {
            handleSearchOrderPayStatus(pay_order_no, true)
          } catch (error: any) {
            Dialog.close()
          }
        })
        .catch(() => {
          Dialog.close()
        })
    }
    if (searching) {
      return
    }
    searching = true
    payNameplateReissueResult(pay_order_no)
      .then((result) => {
        if (result.status === 2) {
          clearToast()
          // 跳转到支付成功页面
          clearInterval(timeId)
          showToastSuccess('支付成功')
          initPageDetail()
          setTimeout(() => {
            // 清除列表缓存
            $store.commit('NameplateReissue/removeCacheRouteName', NameplateReissueList)
          }, 500)
        }
      })
      .catch((error) => {
        console.log('error', error)
      })
      .finally(() => {
        searching = false
        i++
      })
  }
  if (immediately) {
    handleFn()
  } else {
    timeId = setInterval(async () => {
      // 如果查询时间超过1分钟 那么停止查询并提示
      handleFn()
    }, 5000)
  }
  //
}
// 支付成功页面
const getCbPageUrl = (): string => {
  return `/nameplate-reissue/pay-success/${detail.value.order_no}/${detail.value.guid}/${detail.value.pay_amount}`
}
async function payHandle() {
  if (!invoiceVerify()) {
    scrollToInvoiceDom()
    return
  }
  try {
    await showConfirmModal({
      title: '提示',
      message: '是否确认支付',
      className: 'nongfu-dialog-confirm-class nongfu-dialog-message-center',
      cancelButtonText: '取消',
      confirmButtonText: '确定',
    })
  } catch (error) {
    return
  }
  const canUseCmbPay = await judgeCanUseMiniProgramPay()
  try {
    const params = {
      from: isMiniProgram.value ? 'applets' : 'app',
      payment_platform: canUseCmbPay ? 'merchants_bank' : 'wechat',
      callback_page_url: window.location.origin + getCbPageUrl(),
    }
    showToastLoading()
    console.log('支付params', params)
    const result = await payNameplateReissue($route.query.guid as string, params)
    $store.commit('NameplateReissue/removeCacheRouteName', NameplateReissueDetail)
    $store.commit('NameplateReissue/removeCacheRouteName', NameplateReissueList)
    clearToast()
    let needSearch = true
    if (params.from === 'applets') {
      wx.miniProgram.navigateTo({
        url: '/pages/user/pay?guid=' + result.pay_order_no,
      })
    } else {
      const userAgree = await compatibleWechatAndCmdPay(result.pay_order_no)
      if (!userAgree) {
        needSearch = false
      }
    }
    needSearch && handleSearchOrderPayStatus(result.pay_order_no)
    return
  } catch (error) {
    commonErrorHandle(error)
  }
}
async function clickHandler() {
  switch (detail.value.status) {
    case 20: {
      $store.commit('NameplateReissue/removeCacheRouteName', NameplateReissueApply)
      $store.commit('NameplateReissue/removeCacheRouteName', NameplateReissueDetail)
      $store.commit('NameplateReissue/removeCacheRouteName', NameplateReissueList)
      $router.replace({
        name: 'nameplate-reissue-apply',
        query: {
          guid: detail.value.guid,
        },
      })
      break
    }
    case 50:
      {
        try {
          await showConfirmModal({
            title: '提示',
            message: '是否确认收货',
            className: 'nongfu-dialog-confirm-class nongfu-dialog-message-center',
            cancelButtonText: '取消',
            confirmButtonText: '确定',
          })
          try {
            showToastLoading()
            await receiptNameplateReissue(detail.value.guid)
            clearToast()
            initPageDetail()
            $store.commit('NameplateReissue/removeCacheRouteName', NameplateReissueList)
          } catch (error) {
            console.log(error)
            commonErrorHandle(error)
          }
        } catch (e) {
          console.log(e)
        }
      }
      break
    case 30: {
      payHandle()
      break
    }
  }
}
function leftClickHandle() {
  console.log('leftClickHandle')
  clearInterval(timeId)
  clearToast()
  if ($route.query.ifFormConfirmSuccess) {
    $store.commit('NameplateReissue/removeCacheRouteName', NameplateReissueList)
  }
  $router.replace({
    name: 'nameplate-reissue-list',
  })
}
let scriptItem: HTMLScriptElement
function connectCustomerServiceHandle() {
  if (isApp) {
    console.log('AppHost', AppHost)
    AppHost.postSobotChat()
  } else {
    // showToastLoading()
    window?.ClinkChatWeb && window?.ClinkChatWeb.openSessionWindow()
  }
}
onMounted(() => {
  if (!isApp && !window?.ClinkChatWeb) {
    ;(function (win, doc, src, opt: any) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      win[opt] =
        win[opt] ||
        function () {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          win[opt].options = arguments[0]
        }
      var script = doc.createElement('script')
      script.async = true
      script.src = src
      doc.body.appendChild(script)
    })(
      window,
      document,
      `${location.protocol}//webchat1-bj.clink.cn/webchat.js?v=${Date.now()}`,
      'clinkWebchatOptions'
    )
    window.clinkWebchatOptions({
      accessId: 'b884b6ad-8284-44d4-89f1-5a565bb529f4',
      language: 'zh_CN',
    })
  }
})
onDeactivated(() => {
  scriptItem && document.body.removeChild(scriptItem)
  clearInterval(timeId)
  clearToast()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, {
      title: "申请单详情",
      isReturnLeftEvent: true,
      onLeftClick: leftClickHandle
    }),
    _createVNode(_unref(PullRefresh), {
      modelValue: refreshing.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((refreshing).value = $event)),
      onRefresh: onRefresh,
      class: "detail-wrap"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                class: "status-text",
                style: _normalizeStyle('color:' + _unref(detail).statusColor)
              }, _toDisplayString(_unref(detail).statusText), 5),
              (_unref(isShowCancel))
                ? (_openBlock(), _createBlock(_unref(Button), {
                    key: 0,
                    class: "cancel-button",
                    onClick: cancelHandle
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("取消单据")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createTextVNode(" 申请单号：" + _toDisplayString(_unref(detail).sn) + " ", 1),
              _hoisted_5
            ]),
            (_unref(isNotPassed))
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, "审核意见：" + _toDisplayString(_unref(detail).verified_description), 1),
                  _createElementVNode("div", { class: "problem" }, [
                    _createTextVNode(" 如对审核结果有疑问，可联系"),
                    _createElementVNode("span", {
                      class: "customer",
                      onClick: connectCustomerServiceHandle
                    }, "极小美客服咨询"),
                    _hoisted_8
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(ReceiptInfo, _mergeProps(_unref(detail).receiptInfo, { isShowShipmentNum: _unref(isShowShipmentNum) }), null, 16, ["isShowShipmentNum"]),
          (_unref(isShowDetailBillBlock))
            ? (_openBlock(), _createBlock(DetailBillBlock, {
                key: 0,
                payInfo: _unref(detail).payInfo,
                guid: _unref(detail).guid,
                orderNum: _unref(detail).sn,
                isShowBill: _unref(detail).isShowBill,
                isPayStatus: _unref(detail).status === 30
              }, null, 8, ["payInfo", "guid", "orderNum", "isShowBill", "isPayStatus"]))
            : _createCommentVNode("", true),
          (_unref(canPay))
            ? (_openBlock(), _createBlock(OrderInoviceApply, {
                key: 1,
                onInit: _unref(invoiceDomInit),
                invoiceData: _unref(detail)?.invoice_apply || null
              }, null, 8, ["onInit", "invoiceData"]))
            : _createCommentVNode("", true),
          _createVNode(DeviceInfo, {
            infoArr: _unref(detail).deviceInfo
          }, null, 8, ["infoArr"]),
          _createVNode(ApplyInfo, {
            infoArr: _unref(detail).applyInfo
          }, null, 8, ["infoArr"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_unref(NameplateReissueOrderDetailButtonTextMap).has(_unref(detail).status))
      ? (_openBlock(), _createBlock(CommonFooterWrap, { key: 0 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              (_unref(detail).status === 50)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_13))
                : _createCommentVNode("", true),
              (_unref(detail).status === 20)
                ? (_openBlock(), _createBlock(_unref(Button), {
                    key: 1,
                    class: "re-button",
                    round: "",
                    onClick: clickHandler
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(NameplateReissueOrderDetailButtonTextMap).get(_unref(detail).status)), 1)
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_unref(Button), {
                    key: 2,
                    class: "confirm-button",
                    round: "",
                    onClick: clickHandler
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(NameplateReissueOrderDetailButtonTextMap).get(_unref(detail).status)), 1)
                    ]),
                    _: 1
                  }))
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})